<template>
    <div id="theme-list">
        <div id="worksends-page-header" class="tw-grid tw-mt-2 tw-grid-cols-2">
            <div>
                <div class="breadcrumbs" id="breadcrumbs">
                    <router-link class="breadcrumb-link" to="/surveys/dashboard">Bookblock HUB Surveys</router-link> &gt;
                    <router-link class="breadcrumb-link" to="/surveys/themes">Themes</router-link>
                </div>
                <h3>Your Survey Themes</h3>
                <div class="ws-button ws-button-main" @click="onShowCreate">Create A New Theme</div>
            </div>
            <div class="ws-filters tw-flex tw-justify-end">
                <div class="ws-filter">
                    <label>Active Only</label>
                    <div class="ws-filter-switch" :data-state="(activeOnly) ? 'yes' : 'no'" @click="activeOnly = !activeOnly">
                        <div class="ws-filter-switch-knob"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="jumbotron tw-p-5 tw-rounded tw-flex tw-justify-between tw-flex-col" v-if="loaded && showJumbotron" :class="themes.length?'small':'enlarged'">
            <div class="tw-flex tw-justify-between tw-items-start">
                <h2 class="tw-text-white tw-text-lg">Your Survey - Your Brand. Matched perfectly.</h2>
                <a class="hide tw-text-white tw-text-xs" @click="hideJumbotron">Hide</a>
            </div>
            <div class="desc text-white">
                <p>
                    Survey themes are sets of visual styles that you can save and apply to any survey. 
                    With a full range of customisation options, you can <b>match your brand perfectly</b>. 
                    And if you're looking for some inspiration, have a look into our <router-link to="/surveys/themes/gallery">themes gallery</router-link> 
                    to choose from many professionally curated themes made by our UI experts that fit any purpose.
                </p>
            </div>
            <div class="jumbotron-buttons">
                <div class="ws-button ws-button-white" @click="onShowCreate">
                    <b>Create Custom Theme</b>
                </div>
                <div class="ws-button ws-button-white" @click="$router.push({name: 'surveys-themes-gallery'})">
                    Browse Theme Gallery
                </div>
            </div>
        </div>
        <div class="grid themes tw-mt-4">
            <div v-for="theme in themes" :key="theme.id" class="item theme tw-bg-white tw-rounded" @click="goToDetail(theme.id)">
                <div class="tw-rounded tw-flex tw-flex-col tw-items-flex-start">
                    <div class="page-preview page-preview-template">
                        <page-view 
                            :page="samplePage"
                            :styles="theme.styles"
                            :editable="false"
                            :readonly="true"
                            view="preview-theme"
                        />
                    </div>
                    <h3 class="tw-font-normal">{{ theme.name }}</h3>
                    <div class="status" :class="(theme.active) ? 'status-active' : 'status-inactive'">{{ (theme.active) ? 'Active' : 'Inactive' }}</div>
                    <div class="used-in" :class="{ 'not-used': theme.surveys_count === 0 }">
                        <span v-if="theme.surveys_count > 0">Theme used in <span class="count">{{ theme.surveys_count }}</span> surveys.</span>
                        <span v-else>Theme not in use.</span>
                    </div>
                </div>
                <div class="buttons tw-flex tw-justify-between tw-items-center tw-mt-3">
                    <div class="ws-button small ws-button-main">Edit Theme</div>
                    <div v-if="!theme.active" class="ws-button small ws-button-inverted activate" @click.stop="onActivate(theme)">Activate</div>
                    <div v-if="theme.active" class="ws-button small ws-button-inverted deactivate" @click.stop="onDeactivate(theme)">Deactivate</div>
                </div>
            </div>
        </div>
        
        <modal v-if="showCreateModal" @close="showCreateModal = false">
            <survey-theme-form @save="onCreateTheme" @cancel="showCreateModal = false"/>
        </modal>
    </div>
</template>

<script>
import SurveyThemeForm from "@/pages/surveys/SurveyThemeForm";
import Modal from "@/components/modals/Modal";
import PageView from "@/pages/surveys/PageView.vue";

export default {
    name: 'SurveyThemesList',
    components: {PageView, Modal, SurveyThemeForm},
    data() {
        return {
            activeOnly: undefined,
            showCreateModal: false,
            jumbotron: true,
            loaded: false,
        }
    },
    computed: {
        samplePage() {
            return this.$store.state.surveyThemeSamplePage;
        },
        showJumbotron() {
            return this.$cookies.get('surveys_themes_jumbotron_hidden') ? false : this.jumbotron;
        },
        themes() {
            let themes = this.$store.getters["surveyThemes/orderedList"];
            if (this.activeOnly) {
                themes = themes.filter(({active}) => active)
            }
            return themes
        },
    },
    watch: {
        activeOnly: 'loadMore',
    },
    created() {
        this.loadMore();
    },
    methods: {
        async loadMore() {
            await this.$store.dispatch('surveyThemes/getList', {active: this.activeOnly});
            this.loaded = true;
        },
        onShowCreate() {
            this.showCreateModal = true;
        },
        async onCreateTheme(theme) {
            var created = await this.$store.dispatch('surveyThemes/create', theme);
            await this.$router.push({ name: 'surveys-theme-details', params: { theme_id: created.id }})
        },
        async onActivate(theme) {
            await this.$store.dispatch('surveyThemes/publish', theme);
        },
        async onDeactivate(theme) {
            await this.$store.dispatch('surveyThemes/unpublish', theme);
        },
        goToDetail(id) {
            this.$router.push({ name: 'surveys-theme-details', params: { theme_id: id }})
        },
        hideJumbotron() {
            this.jumbotron = false;
            this.$cookies.set('surveys_themes_jumbotron_hidden', true);
        },
    },
}
</script>
